import { z } from 'zod';
import { USAAddressOptionalSchema, USAAddressSchema } from '../../../constants/sharedSchemas';

const referenceSchema = z.object({
  firstName: z.string().min(1, 'First Name is required'),
  lastName: z.string().min(1, 'First Name is required'),
  address: USAAddressSchema,
  phoneNumber: z.string().min(1, 'Phone number is required'),
  email: z.string().min(1, 'Email address is required').email('Email address is invalid'),
  relationship: z.string().min(1, 'Relationship is required'),
});

const referenceOptionalSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  address: USAAddressOptionalSchema,
  phoneNumber: z.string().optional(),
  email: z.union([z.literal(''), z.string().email('Email is invalid').optional()]),
  relationship: z.string().optional(),
});

export const personalReferencesSchema = {
  required: z.object({
    reference1: referenceSchema,
    reference2: referenceSchema,
  }),
  optional: z.object({
    reference1: referenceOptionalSchema,
    reference2: referenceOptionalSchema,
  }),
};

export type PersonalReferencesFormValues = z.infer<(typeof personalReferencesSchema)['required']> | z.infer<(typeof personalReferencesSchema)['optional']>;

export const defaultValues: PersonalReferencesFormValues = {
  reference1: {
    firstName: '',
    lastName: '',
    address: undefined,
    phoneNumber: '',
    email: '',
    relationship: '',
  },
  reference2: {
    firstName: '',
    lastName: '',
    address: undefined,
    phoneNumber: '',
    email: '',
    relationship: '',
  },
};
